// extracted by mini-css-extract-plugin
module.exports = {"routeHeader":"service-types_routeHeader_1F09P","addButton":"service-types_addButton_IkGmL"};